import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import type {
  SalesforceAccountResponse,
  EntitySearchQueryResult,
} from 'types/api-responses';
import type { DivisionOrderResult, DivisionOrderStatistics } from './types';

export interface DivisionOrdersSearchParams extends SearchParams {
  interestTypes?: string[];
  lineItemStatuses?: string[];
  operatorId?: string;
  entityId?: number;
  crmAccountId?: string;
  // Exact-match filter on a line item's UWI (nested term query on the BE).
  // Use this — not free-text `text` — to find DOs that touch a given well,
  // since `line_items.uwi` is a nested mapping that simple_query_string can't
  // reach.
  lineUwi?: string;
  sources?: Array<'Salesforce' | 'Provisioned'>;
  // Legacy single-range support
  dateFilterType?: string;
  dateStart?: string;
  dateEnd?: string;
  // Per-field date ranges (mock-aligned)
  dateReceivedStart?: string;
  dateReceivedEnd?: string;
  createdAtStart?: string;
  createdAtEnd?: string;
  updatedAtStart?: string;
  updatedAtEnd?: string;
}

export const createDivisionOrdersSearchAtom = () =>
  searchAtomPair<
    DivisionOrderResult,
    DivisionOrdersSearchParams,
    undefined,
    DivisionOrderStatistics
  >({ href: '/queries/division_orders' });

// Filter-panel atoms are exposed as factories so each mounted instance can
// scope state via useMemo — the list page, entity tab, and well-page accordion
// each render the filters and must not share operator/entity search state.
export const createOperatorAccountsAtom = () =>
  searchAtomPair<
    SalesforceAccountResponse,
    { text?: string; pageSize?: number }
  >({ href: '/queries/crm/accounts' });

export const createEntitiesAtom = () =>
  searchAtomPair<
    EntitySearchQueryResult,
    { text?: string; pageSize?: number; responseMode?: string }
  >({ href: '/queries/entities' });
